import React, { useState, useEffect } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import axios from "../helper/axios";
import ProductFilterTable from "../components/ProductFilterTable";
import FormatPrice from "../helper/FormatPrice";

const RangeSlider = () => {
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);

  const [minCarat, setMinCarat] = useState(0.01);
  const [maxCarat, setMaxCarat] = useState(0.01);

  const [allProducts, getAllProducts] = useState([]);

  const [sortOption, setSortOption] = useState("");

  const [colorValue, setColorValue] = useState([0, 5]);
  const [color, setColor] = useState([]);

  const [cutValue, setCutValue] = useState([0, 4]);
  const [cut, setCut] = useState([]);

  const [clarityValue, setClarityValue] = useState([0, 6]);
  const [clarity, setClarity] = useState([]);

  const [filteredProduct, setFilteredProduct] = useState([]);

  const [dataFetched, setDataFetched] = useState(false);

  useEffect(() => {
    fetchDiamondData();
  }, []);

  useEffect(() => {
    filterAndSortProducts();
  }, [
    allProducts,
    minCarat,
    maxCarat,
    minPrice,
    maxPrice,
    sortOption,
    color,
    colorValue,
    cut,
    cutValue,
    clarity,
    clarityValue,
  ]);

  const handlePriceRangeChange = (value) => {
    setMinPrice(value[0]);
    setMaxPrice(value[1]);
  };

  const handleCaratRangeChange = (value) => {
    setMinCarat(value[0]);
    setMaxCarat(value[1]);
  };

  // useEffect(() => {
  //   setFilteredProduct(allProducts);
  // }, [allProducts]);

  // useEffect(() => {
  // const filterAndSortProducts = () => {
  //   let filteredProducts = allProducts;

  //   // filteredProducts = filteredProducts.filter(
  //   //   (product) =>
  //   //     product.product_price >= minPrice && product.product_price <= maxPrice
  //   // );

  //   // filteredProducts = filteredProducts.filter(
  //   //   (product) => product.carat >= minCarat && product.carat <= maxCarat
  //   // );

  //   if (sortOption === "priceHighToLow") {
  //     filteredProducts.sort((a, b) => b.product_price - a.product_price);
  //   } else if (sortOption === "priceLowToHigh") {
  //     filteredProducts.sort((a, b) => a.product_price - b.product_price);
  //   } else if (sortOption === "nameAZ") {
  //     filteredProducts.sort((a, b) =>
  //       a.product_name.localeCompare(b.product_name)
  //     );
  //   }

  //   setFilteredProduct(filteredProducts);
  // };

  //   filterAndSortProducts();
  // }, [allProducts, minCarat, maxCarat, minPrice, maxPrice, sortOption]);

  const filterAndSortProducts = () => {
    let filteredProducts = [...allProducts];

    filteredProducts = filterProductsByPrice(
      minPrice,
      maxPrice,
      filteredProducts
    );
    filteredProducts = filterProductsByCarat(
      minCarat,
      maxCarat,
      filteredProducts
    );

    filteredProducts = filterProductsByColor(colorValue, filteredProducts);

    filteredProducts = filterProductsByCut(cutValue, filteredProducts);

    filteredProducts = filterProductsByClarity(clarityValue, filteredProducts);

    if (sortOption === "priceHighToLow") {
      filteredProducts.sort((a, b) => b.product_price - a.product_price);
    } else if (sortOption === "priceLowToHigh") {
      filteredProducts.sort((a, b) => a.product_price - b.product_price);
    } else if (sortOption === "nameAZ") {
      filteredProducts.sort((a, b) =>
        a.product_name.localeCompare(b.product_name)
      );
    } else if (sortOption === "new") {
      filteredProducts.sort(
        (a, b) =>
          new Date(b.product_created_on) - new Date(a.product_created_on)
      );
    }

    setFilteredProduct(filteredProducts);
  };

  const filterProductsByPrice = (minPrice, maxPrice, products) => {
    return products.filter(
      (product) =>
        product.product_price >= minPrice && product.product_price <= maxPrice
    );
  };

  const filterProductsByCarat = (minCarat, maxCarat, products) => {
    return products.filter(
      (product) => product.carat >= minCarat && product.carat <= maxCarat
    );
  };

  // Add color filtering function
  // const filterProductsByColor = (colorValue, products) => {
  //   return products.filter(
  //     (product) =>
  //       product.color_id >= color[colorValue[0]].color_id &&
  //       product.color_id <= color[colorValue[1]].color_id
  //   );
  // };

  const filterProductsByColor = (colorValue, products) => {
    if (!color || color.length === 0) {
      return [];
    }

    const startColor = color[colorValue[0]];
    const endColor = color[colorValue[1]];

    return products.filter(
      (product) =>
        product.color_id >= startColor.color_id &&
        product.color_id <= endColor.color_id
    );
  };

  const filterProductsByCut = (cutValue, products) => {
    if (!cut || cut.length === 0) {
      return [];
    }

    const startCut = cut[cutValue[0]];
    const endCut = cut[cutValue[1]];

    return products.filter(
      (product) =>
        product.cut_id >= startCut.cut_id && product.cut_id <= endCut.cut_id
    );
  };

  const filterProductsByClarity = (clarityValue, products) => {
    if (!clarity || clarity.length === 0) {
      return [];
    }

    const startClarity = clarity[clarityValue[0]];
    const endClarity = clarity[clarityValue[1]];

    return products.filter(
      (product) =>
        product.clarity_id >= startClarity.clarity_id &&
        product.clarity_id <= endClarity.clarity_id
    );
  };

  const fetchDiamondData = async () => {
    try {
      const category = { category: ["Diamond"] };
      const response = await axios.post("/product_read", category);
      const allProducts = response.data.data;
      getAllProducts(allProducts);
      console.log(allProducts);

      const colorData = await axios.get("/color_read");
      const colorProduct = colorData.data.data.slice(0, -1);

      const combinedColorData = colorProduct.map((colorItem) => ({
        color_id: colorItem.color_id,
        color_name: colorItem.color_name,
      }));
      setColor(combinedColorData);

      const cutData = await axios.get("/cut_read");
      const cutProduct = cutData.data.data.slice(0, -1);

      const combinedcutData = cutProduct.map((cutItem) => ({
        cut_id: cutItem.cut_id,
        cut_name: cutItem.cut_name,
      }));
      setCut(combinedcutData);

      const clarityData = await axios.get("/clarity_read");
      const clarityProduct = clarityData.data.data.slice(0, -1);

      const combinedClarityData = clarityProduct.map((clarityItem) => ({
        clarity_id: clarityItem.clarity_id,
        clarity_name: clarityItem.clarity_name,
      }));
      setClarity(combinedClarityData);
      setDataFetched(true);
      // const metalData = await axios.get("/metal_read");
      // const metalProduct = metalData.data.data;
      // setAllMetalResponse(metalProduct);
      // const metalArray = Object.values(metalProduct).map(
      //   (metal) => metal.metal_name
      // );
      // setMetal(metalArray.slice(0, -1));

      // const productSettingsData = await axios.get("/product_settings_read");
      // const productSettingsProduct = productSettingsData.data.data;
      // const productSettingsArray = Object.values(productSettingsProduct).map(
      //   (productsettings) => productsettings.product_settings_name
      // );
      // setProductSetting(productSettingsArray.slice(0, -1));

      // const StyleData = await axios.get("/style_read");
      // const StyleProduct = StyleData.data.data;
      // const styleArray = Object.values(StyleProduct).map(
      //   (styleProduct) => styleProduct.style_name
      // );
      // setStyle(styleArray.slice(0, -1));
    } catch (error) {
      console.log("Error In Fetching Data", error.message);
    }
  };

  const allPrices = allProducts.map((product) => product.product_price);
  const initialMinPrice = Math.min(...allPrices);
  const initialMaxPrice = Math.max(...allPrices);

  const allCarat = allProducts.map((product) => product.carat);
  const initialMinCarat = parseFloat(Math.min(...allCarat));
  const initialMaxCarat = parseFloat(Math.max(...allCarat));

  useEffect(() => {
    setMinPrice(initialMinPrice);
    setMaxPrice(initialMaxPrice);

    setMinCarat(initialMinCarat);
    setMaxCarat(initialMaxCarat);
  }, [initialMinPrice, initialMaxPrice, initialMinCarat, initialMaxCarat]);

  // const filterProductsByPrice = (minPrice, maxPrice, products) => {
  //   return products.filter(
  //     (product) =>
  //       product.product_price >= minPrice && product.product_price <= maxPrice
  //   );
  // };

  // const filterProductsByCarat = (minCarat, maxCarat, products) => {
  //   return products.filter(
  //     (product) => product.carat >= minCarat && product.carat <= maxCarat
  //   );
  // };

  // useEffect(() => {
  //   const newFilteredProducts = filterProductsByPrice(
  //     minPrice,
  //     maxPrice,
  //     allProducts
  //   );
  //   setFilteredProduct(newFilteredProducts);
  // }, [minPrice, maxPrice, allProducts]);

  // useEffect(() => {
  //   const newFilteredProducts = filterProductsByCarat(
  //     minCarat,
  //     maxCarat,
  //     allProducts
  //   );
  //   setFilteredProduct(newFilteredProducts);
  // }, [minCarat, maxCarat, allProducts]);

  const resetSlider = () => {
    setMinPrice(initialMinPrice);
    setMaxPrice(initialMaxPrice);
    setMinCarat(initialMinCarat);
    setMaxCarat(initialMaxCarat);
    setColorValue([0, 5]);
    setCutValue([0, 4]);
    setClarityValue([0, 6]);
    // setViewAllClicked(true);
    setSortOption("select");
  };

  const handleSortChange = (event) => {
    const selectedOption = event.target.value;
    setSortOption(selectedOption);
  };

  useEffect(() => {
    setSortOption("select");
  }, [
    minPrice,
    maxPrice,
    minCarat,
    maxCarat,
    colorValue,
    cutValue,
    clarityValue,
  ]);

  // // const [caretValue,setCaretValue] = useState([0, 1]); //
  // // const [cutValue, setCutValue] = useState([0,1]);

  // const [products, setProducts] = useState([]); // Default range values

  // // const [cut,setCut] = useState([]);
  // const [data, setData] = useState([]);

  // //   const [minPrice, setMinPrice] = useState(0);
  // //   const [maxPrice, setMaxPrice] = useState(0);
  // //   const [price, setPrice] = useState([]);
  // const [priceData, setPriceData] = useState([]);
  // const [minPriceValue, setMinPriceValue] = useState(0);
  // const [maxPriceValue, setMaxPriceValue] = useState(10000000);

  // const [caratData, setCaratData] = useState([]);
  // const [minCaratValue, setMinCaratValue] = useState(0);
  // const [maxCaratValue, setMaxCaratValue] = useState(10);

  // useEffect(
  //   () => {
  //     fetchFilteredProducts();
  //     // getAPIData1();
  //   },
  //   [
  //     // data,
  //     // colorValue,
  //     // minPriceValue,
  //     // maxPriceValue,
  //     // minCaratValue,
  //     // maxCaratValue,
  //   ]
  // );

  //   useEffect(() => {
  //     getAPIData1();
  //     // console.log('̥rangeValue', colorValue);
  //   }, [colorValue,price]);

  //   useEffect(() => {
  //     // Update minPrice and maxPrice whenever priceData changes
  //     if (price.length > 0) {
  //       setMinPrice(Math.min(...price));
  //       setMaxPrice(Math.max(...price));
  //     }
  //   }, [price]);

  // const fetchFilteredProducts = async () => {
  //   try {
  //     const colorData = await axios.get("/color_read");
  //     const colorProduct = colorData.data.data.slice(0, -1);
  //     console.log(colorProduct, "Color Product");

  //     const combinedColorData = colorProduct.map((colorItem) => ({
  //       color_id: colorItem.color_id,
  //       color_name: colorItem.color_name,
  //     }));
  //     setColor(combinedColorData);
  //     console.log(combinedColorData, "Combined Color");

  //     // console.log(price)

  //     // const cutData = await axios.get('/cut_read');
  //     // const cutProduct = cutData.data.data.slice(0, -1);
  //     // console.log(cutProduct, "Cut Product")
  //     // // Combine cut_ids and cut_names into a single array of objects
  //     // const combinedCutData = cutProduct.map(cutItem => ({
  //     //     cut_id: cutItem.cut_id,
  //     //     cut_name: cutItem.cut_name,
  //     // }));
  //     // setCut(combinedCutData);
  //     // console.log(combinedCutData, "Combined Cut")
  //   } catch (error) {
  //     console.log("̥Error In Fetiching Data", error.message);
  //   }
  // };

  // const getAPIData1 = async () => {
  //   try {
  //     // if (color.length === 0) {
  //     //     console.log('// No data yet, wait for the color state to be populated̥');
  //     //     return;
  //     // }

  //     //Nikunj
  //     // const category = "diamond";
  //     // let url = `/product_read?category=${category}&`;
  //     // if (colorValue.length > 0) {
  //     //   url += `from_color=${color[colorValue[0]].color_name}&to_color=${
  //     //     color[colorValue[1]].color_name
  //     //   }`;
  //     //   // console.log(
  //     //   //   "̥color[colorValue[0]].color_name}",
  //     //   //   color[colorValue[0]].color_name
  //     //   // );
  //     // }

  //     // if (priceData.length > 0) {
  //     //   url += `&from_price=${minPriceValue}&to_price=${maxPriceValue}`;
  //     // }

  //     // if(caratData.length > 0) {
  //     //   url += `&min_carat=${minCaratValue}&max_carat=${maxCaratValue}`;
  //     // }
  //     //Nikunj

  //     // const category = {category :["diamond"]};
  //     // const filteredDiamond = {
  //     //   category: ["Diamond"],
  //     //   // from_color: color[colorValue[0]].color_name,
  //     //   // to_color: color[colorValue[1]].color_name,
  //     //   from_price: minPriceValue,
  //     //   to_price: maxPriceValue,
  //     //   min_carat: minCaratValue,
  //     //   max_carat: maxCaratValue,
  //     // };

  //     // if (cutValue.length > 0) {
  //     //     url += `cut=${cut[cutValue[0]].cut_name}`;
  //     //     console.log('̥cut', cut[cutValue[0]].cut_name);
  //     // }

  //     // console.log('̥url', url);
  //     // if (color.length > 0) {
  //     // }

  //     // color[colorValue[0]].color_name;

  //     // if (shapeSliderValue.length > 0) {
  //     //     const start = shapeSlider[0];
  //     //     const end = shapeSlider[1];
  //     //     const sum = shapeData.slice(start, end + 1);

  //     //     // console.log('̥sum', sum);
  //     //     sum.map((shape) => (
  //     //         url += `&shape=${shape}`
  //     //         // console.log('̥', shape)
  //     //     ))
  //     // }

  //     // if (cutSliderValue.length > 0) {
  //     //     url += `&from_cut=${cutSliderValue[0]}&to_cut=${cutSliderValue[1]}`;
  //     // }
  //     // if (caratSliderValue.length > 0) {
  //     //     url += `&min_carat=${caratSliderValue[0]}&max_carat=${caratSliderValue[1]}`;
  //     // }
  //     // if (priceSliderValue.length > 0) {
  //     //     url += `&from_price=${priceSliderValue[0]}&to_price=${priceSliderValue[1]}`;
  //     // }
  //     // const allData = { 'category': ["diamond"] };

  //     // const res = await axios.post("/product_read", filteredDiamond);
  //     // console.log("data", res.data.data);
  //     // setData(res.data.data);
  //     const colorFilter = {}
  //     const colorData = await axios.post("/color_read",colorFilter);
  //     const colorProduct = colorData.data.data.slice(0, -1);
  //     console.log(colorProduct, "Color Product")

  //     // Combine color_ids and color_names into a single array of objects
  //     const combinedColorData = colorProduct.map((colorItem) => ({
  //       color_id: colorItem.color_id,
  //       color_name: colorItem.color_name,
  //     }));
  //     setColor(combinedColorData);
  //     console.log(combinedColorData, "Combined Color")

  //     const allPrices = data.map((product) => product.product_price);
  //     setPriceData(allPrices);

  //     const allCarats = data.map((product) => product.carat);
  //     setCaratData(allCarats);
  //     //   data.map((item) => {
  //     //     setPrice(item.product_price);
  //     //   });

  //     // const json = await res.data.products;
  //     // // console.log('̥json', json);
  //     // console.log('setMyDatḁ',json);
  //     // console.log('myData', myData);
  //   } catch (error) {
  //     console.log("̥Error In Fetiching Data", error.message);
  //   }
  // };

  const handleColorChange = (value) => {
    setColorValue(value);

    if (color.length === 0) return;

    const selectedColors = value.map((index) => color[index].color_name);
    const filteredProducts = allProducts.filter((product) =>
      selectedColors.includes(product.color)
    );
    setFilteredProduct(filteredProducts);
  };

  const handleCutChange = (value) => {
    setCutValue(value);

    if (cut.length === 0) return;

    const selectedCuts = value.map((index) => cut[index].cut_name);
    const filteredProducts = allProducts.filter((product) =>
      selectedCuts.includes(product.cut)
    );
    setFilteredProduct(filteredProducts);
  };

  const handleClarityChange = (value) => {
    setClarityValue(value);

    if (clarity.length === 0) return;

    const selectedClarities = value.map((index) => clarity[index].clarity_name);
    const filteredProducts = allProducts.filter((product) =>
      selectedClarities.includes(product.clarity)
    );
    setFilteredProduct(filteredProducts);
  };

  // console.log(filteredProduct);

  // console.log(allProducts, "allProducts");
  // console.log(filteredProduct, "filteredProduct");
  // console.log(color, "Color", colorValue, "Color Value");
  // const handlePriceChange = (values) => {
  //   setMinPriceValue(values[0]);
  //   setMaxPriceValue(values[1]);
  // };

  // const handleCaratChange = (values) => {
  //   setMinCaratValue(values[0]);
  //   setMaxCaratValue(values[1]);
  // };

  //   console.log(price, "Price");

  // const handleCaretChange = (value) => {
  //     setCaretValue(value);
  // };

  // const handleCutChange = (value) => {
  //     setCutValue(value);
  // }

  // if (color.length === 0) {
  //   return <div>Loading color data...</div>;
  // }

  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-6">
              <div style={{ margin: "20px" }}>
                <label htmlFor="color">Select Price:</label>
                <Slider
                  range
                  allowCross={false}
                  value={[minPrice, maxPrice]}
                  onChange={handlePriceRangeChange}
                  min={initialMinPrice}
                  max={initialMaxPrice}
                  step={1}
                  id="price"
                  name="price"
                  list="price"
                  className="my-2"
                />
                <div className="row">
                  <div className="form-group col-3 text-start ms-0">
                    <label htmlFor="minPrice">Min Price</label>
                    <input
                      type="number"
                      id="minPrice"
                      name="minPrice"
                      value={minPrice}
                      onChange={(e) => setMinPrice(parseFloat(e.target.value))}
                      step={1000}
                      min={initialMinPrice}
                      max={initialMaxPrice}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group col-3 text-end ms-auto">
                    <label htmlFor="maxPrice">Max Price</label>
                    <input
                      type="number"
                      id="maxPrice"
                      name="maxPrice"
                      value={maxPrice}
                      onChange={(e) => setMaxPrice(parseFloat(e.target.value))}
                      step={1000}
                      min={initialMinPrice}
                      max={initialMaxPrice}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-6">
              <div style={{ margin: "20px" }}>
                <label htmlFor="color">Select Carat:</label>

                <Slider
                  range
                  allowCross={false}
                  value={[minCarat, maxCarat]}
                  onChange={handleCaratRangeChange}
                  min={initialMinCarat}
                  max={initialMaxCarat}
                  step={0.01}
                  id="carat"
                  name="carat"
                  list="carat"
                  className="my-2"
                />

                <div className="row">
                  <div className="form-group col-3 text-start ms-0">
                    <label htmlFor="minCarat">Min Carat</label>
                    <input
                      type="number"
                      id="minCarat"
                      name="minCarat"
                      value={minCarat}
                      onChange={(e) => setMinCarat(parseFloat(e.target.value))}
                      step={0.01}
                      min={initialMinCarat}
                      max={initialMaxCarat}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group col-3 text-end ms-auto">
                    <label htmlFor="maxCarat">Max Carat</label>
                    <input
                      type="number"
                      id="maxCarat"
                      name="maxCarat"
                      value={maxCarat}
                      onChange={(e) => setMaxCarat(parseFloat(e.target.value))}
                      step={0.01}
                      min={initialMinCarat}
                      max={initialMaxCarat}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div style={{ margin: "20px" }}>
                <label htmlFor="color" className="my-2">
                  Select a Color:
                </label>

                <Slider
                  range
                  allowCross={false}
                  value={colorValue}
                  onChange={handleColorChange}
                  min={0}
                  max={color.length - 1}
                  step={1}
                  id="color"
                  name="color"
                  list="color"
                />

                <datalist className="color w-100" id="color">
                  {color.map((colorItem, index) => (
                    <option key={index} value={colorItem.color_id}>
                      {colorItem.color_name}
                    </option>
                  ))}
                </datalist>

                {/* <div style={{ marginTop: "20px" }}>
                  Range: {color[colorValue[0]].color_name} -{" "}
                  {color[colorValue[1]].color_name}
                </div> */}

                {/* {color.length > 0 && (
                  <div className="text-center my-2">
                    Selected color range:{" "}
                    {colorValue
                      .filter((index) => index >= 0 && index < color.length)
                      .map((index) => color[index].color_name)
                      .join(", ")}
                  </div>
                )} */}

                {/* <div>
                  Selected color range:{" "}
                  {colorValue
                    .map(
                      (index) =>
                        `${color[index].color_id} - ${color[index].color_name}`
                    )
                    .join(", ")}
                </div> */}
              </div>
            </div>

            <div className="col-6">
              <div style={{ margin: "20px" }}>
                <label htmlFor="cut" className="my-2">
                  Select a Cut:
                </label>

                <Slider
                  range
                  allowCross={false}
                  value={cutValue}
                  onChange={handleCutChange}
                  min={0}
                  max={cut.length - 1}
                  step={1}
                  id="cut"
                  name="cut"
                  list="cut"
                />

                <datalist className="cut w-100 text-center" id="cut">
                  {cut.map((cutItem, index) => (
                    <option key={index} value={cutItem.cut_id}>
                      {cutItem.cut_name}
                    </option>
                  ))}
                </datalist>

                {/* {cut.length > 0 && (
                  <div className="text-center my-2">
                    Selected Cut Range:{" "}
                    {cutValue
                      .filter((index) => index >= 0 && index < cut.length)
                      .map((index) => cut[index].cut_name)
                      .join(", ")}
                  </div>
                )} */}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div style={{ margin: "20px" }}>
                <label htmlFor="clarity" className="my-2">
                  Select a Clarity:
                </label>

                <Slider
                  range
                  allowCross={false}
                  value={clarityValue}
                  onChange={handleClarityChange}
                  min={0}
                  max={clarity.length - 1}
                  step={1}
                  id="clarity"
                  name="clarity"
                  list="clarity"
                />

                <datalist className="clarity w-100 text-center" id="clarity">
                  {clarity.map((clarityItem, index) => (
                    <option key={index} value={clarityItem.clarity_id}>
                      {clarityItem.clarity_name}
                    </option>
                  ))}
                </datalist>

                {/* {clarity.length > 0 && (
                    <div className="text-center my-2">
                      Selected Clarity Range:{" "}
                      {clarityValue
                        .filter((index) => index >= 0 && index < clarity.length)
                        .map((index) => clarity[index].clarity_name)
                        .join(", ")}
                    </div>
                  )} */}
              </div>
            </div>
            <div className="col-6">
              <div style={{ margin: "20px" }}>
                <label htmlFor="sortOption" className="my-2">
                  Sort by:
                </label>
                <select
                  id="sortOption"
                  name="sortOption"
                  value={sortOption}
                  onChange={handleSortChange}
                  className="form-select w-90"
                >
                  <option value="select">--Select--</option>
                  <option value="best">Best Sellers</option>
                  <option value="top">Top Rated</option>
                  <option value="new">Newest</option>
                  <option value="priceHighToLow">Price High to Low</option>
                  <option value="priceLowToHigh">Price Low to High</option>
                  <option value="nameAZ">Name A to Z</option>
                </select>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="price-slider-label text-center my-2">
              <button className="btn m-2" onClick={resetSlider}>
                <b>Reset Filters</b>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* nikunj */}
      {/* <section>
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <div style={{ margin: '20px' }}>
                                <label htmlFor="color">Select Price:</label>

                                <Slider
                                    range
                                    allowCross={false}
                                    value={cutValue}
                                    onChange={handlePriceChange}
                                    min={0}
                                    max={100000}
                                    step={1}
                                    id="price"
                                    name="price"
                                    list="price"
                                />

                                <datalist className="color w-100 text-center" id="color">
                                    {cut.map((cutItem, index) => (
                                        <option key={index} value={cutItem.cut_id}>{cutItem.cut_name}</option>
                                    ))}
                                </datalist>

                                <div style={{ marginTop: '20px' }}>
                                    Range: {cut[cutValue[0]].cut_name} - {cut[cutValue[1]].cut_name}
                                </div>

                                <div>Selected Cut range: {cutValue.map(index => `${cut[index].cut_name}`).join(', ')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

      <section>
        <div className="container product-data-container">
          {dataFetched ? (
            <div className="row">
              <div className="product-data-table-block mt-2 w-100">
                <h3 className="mb-5">
                  {filteredProduct.length} Product Available
                </h3>
                {filteredProduct.length > 0 ? (
                  <div className="product-data-table-block mt-2 w-100">
                    <div className="table__container">
                      <table className="table__items" width="100%">
                        <thead>
                          <tr>
                            <th align="left">&nbsp;</th>
                            <th align="left">Name</th>
                            <th align="left">Clarity</th>
                            <th align="left">Shape</th>
                            <th align="left">Carat</th>
                            <th align="left">Cut</th>
                            <th align="left">Color</th>
                            <th align="left">Price</th>
                            <th align="left">&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredProduct.map((curElem, index) => (
                            <ProductFilterTable key={index} {...curElem} />
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <p>No Products Available !</p>
                )}
              </div>
            </div>
          ) : (
            <p>Loading data...</p>
          )}
        </div>
      </section>
    </>
  );
};

export default RangeSlider;
